import { createContext, use } from "react";
import invariant from "tiny-invariant";
import type { ScriptModule } from "virtual:script";

export type ScriptContextValue = {
  script: ScriptModule;
  language: ScriptLang;
  setLanguagePickerVariant: (variant: "subtle" | "labeled") => void;
};

export const ScriptContext = createContext<ScriptContextValue | null>(null);

export function useScript() {
  const context = use(ScriptContext);
  invariant(context, "`useScript` must be used within a `ScriptProvider`");
  return context;
}
